// @flow
import React from "react";
import { localize } from "redux-i18n";
import { GSGrid, View } from "@components";
import { formatDateTime } from "@transformers/date";

type Props = $Exact<{
  data: *,
  ...PropsFromLocalize,
}>;

export const ReferralQuestionsTable = ({ data, t }: Props) => {
  const questions = data.map(item => {
    let answer = item.answer.value;

    item.answer.type === "DATE" ? formatDateTime(item.answer.value) : item.answer.value;

    switch (item.answer.type) {
      case "DATE":
        answer = formatDateTime(item.answer.value);
        break;

      case "TEXT_LIST":
        answer = answer.join(", ");
        break;

      default:
        answer = item.answer.value;
    }

    return {
      id: item.question.id,
      question: item.question.question,
      answer,
    };
  });

  return (
    <View name="ReferralQuestionsTable" gap={3}>
      <h5>{t("REFERRAL_QUESTIONS")}</h5>
      <GSGrid
        rows={questions}
        columns={[
          {
            name: t("ID"),
            key: "id",
          },
          {
            name: t("QUESTION"),
            key: "question",
            minWidth: 700,
            align: "left",
          },
          {
            name: t("ANSWER"),
            align: "left",
            key: "answer",
          },
        ]}
      />
    </View>
  );
};

export default localize()(ReferralQuestionsTable);
